module.exports = __webpack_public_path__ + "img/uee_token.brpg.942cf46.png";